export default {
  distanceToStart: 'กิจกรรมจะเริ่มใน',
  distanceToEnd: 'กิจกรรมจะสิ้นสุดใน',
  ended: 'กิจกรรมสิ้นสุดแล้ว',
  moonPhase: {
    introduction: 'ระดับดวงจันทร์จะเพิ่มขึ้นตามความคืบหน้าการเติม เพชรรุ้ง สะสมของผู้เล่นทุกคนตลอดระยะเวลากิจกรรม เมื่อถึงพระจันทร์เต็มดวง ผู้เล่นทุกคนที่เข้าร่วมกิจกรรมจะได้รับรางวัลลิมิเต็ดพระจันทร์เต็มดวง [ฉายา - จันทร์เต็มดวงใบไม้ร่วงโรย]',
    new_moon: 'จันทร์ดับ',
    crescent_moon: 'จันทร์เสี้ยวข้างขึ้น',
    first_quarter: 'จันทร์ครึ่งดวงข้างขึ้น',
    gibbous_moon: 'จันทร์ข้างขึ้นเกือบเต็มดวง',
    full_moon: 'พระจันทร์เต็มดวง',
  },
  rewards: {
    clickHere: 'คลิกที่นี่',
    introduceText1: 'ไปที่ศูนย์เติมเงินอย่างเป็นทางการ [{clickHere}]. เติมเงินสะสมครบ 200/500/1,000/3,000/5,000/8,000 เพชรรุ้ง เพื่อรับรางวัลตามเป้าหมาย',
    introduceText2: 'ระยะเวลากิจกรรม: 25 ก.ย. 2026 เวลา 00:00 – 4 ต.ค. 2026 เวลา 23:59 (GMT+7)',
    introduceText3: 'สามารถรับรางวัลได้ถึงวันที่ 4 ต.ค. 2026 เวลา 23:59 (GMT+7)',
  }
}